module.exports = __webpack_public_path__ + "img/suzuki-swift.fcb8993e.jpg";